<template>
  <div>
    <b-breadcrumb :items="breadcrumb"/>
    <h1>Search Applications</h1>
    <b-form @submit.prevent="searchApps" inline>
      <b-form-group label="Select Search Criteria">
        <b-form-select v-model="filterType">
          <option value="email">Email</option>
          <option value="firstName">First Name</option>
          <option value="lastName">Last Name</option>
        </b-form-select>
        <b-input v-model="filterInput" id="filter-input" placeholder="search"/>
        <b-button @click="searchApps" :disabled="isSearching" variant="primary">Search</b-button>
        <div v-if="isSearching" class="loader">Loading...</div>
      </b-form-group>
    </b-form>
    <b-table striped hover :fields="fields" :items="filteredApps">
      <template slot="completed" slot-scope="data">
        <i v-if="data.item.completed" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="teamLeader" slot-scope="data">
        <i v-if="data.item.teamLeader" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="financialAid" slot-scope="data">
        <i v-if="data.item.financialAid" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="view" slot-scope="data">
        <router-link :to="{ name: 'ViewApp', params: { username: data.item.username } }">
          View App
        </router-link>
      </template>
    </b-table>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SearchApps',
    data () {
      return {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'Home' }
          },
          {
            text: 'Search Apps by User',
            to: { name: 'SearchApps' }
          }
        ],
        fields: [
          'firstName',
          'lastName',
          'email',
          'svId',
          'completed',
          'teamLeader',
          'financialAid',
          'view'
        ],
        filterType: 'email',
        filterInput: '',
        isSearching: false
      }
    },
    computed: {
      ...mapState('admin', ['filteredApps'])
    },
    methods: {
      searchApps (e) {
        this.isSearching = true
        this.$store.dispatch('admin/searchApplications', {
          filterType: this.filterType,
          filterInput: this.filterInput
        }).then(() => {
          this.isSearching = false
        }).catch(err => {
          console.log(err)
          this.isSearching = false
        })
      }
    }
  }
</script>

<style lang="scss">
  .ion-checkmark {
    color: #20d200;
  }
  .ion-close {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Search.vue